<template>
  <SeoPage page-key="agenziaWebTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'AgenziaWebTicinoPage'
})
</script>

